// Mapping object for template and item count to element selectors
export const templateMapping = {
    template1: {
        2: {
            repeaterId: '#template1Items2Repeater',
            titleElement: '#template1Items2CardTitle',
            descriptionElement: '#template1Items2CardDescription',
            priceElement: '#template1Items2CardPrice',
            buttonElement: '#template1Items2CardButton',
            quickViewButtonElement: '#template1Items2CardQuickViewButton',
            imgElement: '#template1Items2CardProductImg',
            dropDownElement: '#template1Items2CardDropdown'
        },
        3: {
            repeaterId: '#template1Items3Repeater',
            titleElement: '#template1Items3CardTitle',
            descriptionElement: '#template1Items3CardDescription',
            priceElement: '#template1Items3CardPrice',
            buttonElement: '#template1Items3CardButton',
            imgElement: '#template1Items3CardProductImg',
            quickViewButtonElement: '#template1Items3CardQuickViewButton',
            dropDownElement: '#template1Items3CardDropdown'

        },
        4: {
            repeaterId: '#template1Items4Repeater',
            titleElement: '#template1Items4CardTitle',
            descriptionElement: '#template1Items4CardDescription',
            priceElement: '#template1Items4CardPrice',
            buttonElement: '#template1Items4CardButton',
            imgElement: '#template1Items4CardProductImg',
            quickViewButtonElement: '#template1Items4CardQuickViewButton',
            dropDownElement: '#template1Items4CardDropdown'
        }
    },
    template2: {
        2: {
            repeaterId: '#template2Items2Repeater',
            titleElement: '#template2Items2CardTitle',
            descriptionElement: '#template2Items2CardDescription',
            priceElement: '#template2Items2CardPrice',
            buttonElement: '#template2Items2CardButton',
            imgElement: '#template2Items2CardProductImg',
            quickViewButtonElement: '#template2Items2CardQuickViewButton',
            dropDownElement: '#template2Items2CardDropdown'
        },
        3: {
            repeaterId: '#template2Items3Repeater',
            titleElement: '#template2Items3CardTitle',
            descriptionElement: '#template2Items3CardDescription',
            priceElement: '#template2Items3CardPrice',
            buttonElement: '#template2Items3CardButton',
            imgElement: '#template2Items3CardProductImg',
            quickViewButtonElement: '#template2Items3CardQuickViewButton',
            dropDownElement: '#template2Items3CardDropdown'
        },
        4: {
            repeaterId: '#template2Items4Repeater',
            titleElement: '#template2Items4CardTitle',
            descriptionElement: '#template2Items4CardDescription',
            priceElement: '#template2Items4CardPrice',
            buttonElement: '#template2Items4CardButton',
            imgElement: '#template2Items4CardProductImg',
            quickViewButtonElement: '#template2Items4CardQuickViewButton',
            dropDownElement: '#template2Items4CardDropdown'
        }
    },
    template3: {
        2: {
            repeaterId: '#template3Items2Repeater',
            titleElement: '#template3Items2CardTitle',
            descriptionElement: '#template3Items2CardDescription',
            priceElement: '#template3Items2CardPrice',
            buttonElement: '#template3Items2CardButton',
            imgElement: '#template3Items2CardProductImg',
            quickViewButtonElement: '#template3Items2CardQuickViewButton',
            dropDownElement: '#template3Items2CardDropdown'
        },
        3: {
            repeaterId: '#template3Items3Repeater',
            titleElement: '#template3Items3CardTitle',
            descriptionElement: '#template3Items3CardDescription',
            priceElement: '#template3Items3CardPrice',
            buttonElement: '#template3Items3CardButton',
            imgElement: '#template3Items3CardProductImg',
            quickViewButtonElement: '#template3Items3CardQuickViewButton',
            dropDownElement: '#template3Items3CardDropdown'
        },
        4: {
            repeaterId: '#template3Items4Repeater',
            titleElement: '#template3Items4CardTitle',
            descriptionElement: '#template3Items4CardDescription',
            priceElement: '#template3Items4CardPrice',
            buttonElement: '#template3Items4CardButton',
            imgElement: '#template3Items4CardProductImg',
            quickViewButtonElement: '#template3Items4CardQuickViewButton',
            dropDownElement: '#template3Items4CardDropdown'
        }
    },
    template4: {
        1: {
            repeaterId: '#template4Items1Repeater',
            titleElement: '#template4Items1CardTitle',
            descriptionElement: '#template4Items1CardDescription',
            priceElement: '#template4Items1CardPrice',
            buttonElement: '#template4Items1CardButton',
            imgElement: '#template4Items1CardProductImg',
            quickViewButtonElement: '#template4Items1CardQuickViewButton',
            dropDownElement: '#template4Items1CardDropdown'
        },
    }
};

export const suffixCurrencies = [
    'ISK', // Icelandic króna
    'NOK', // Norwegian krone
    'SEK', // Swedish krona
    'DKK', // Danish krone
    'CZK', // Czech koruna
    'HUF', // Hungarian forint
    'PLN', // Polish złoty
    'RUB', // Russian ruble
    'TRY', // Turkish lira
    'ZAR', // South African rand
    'BRL', // Brazilian real
    'MXN', // Mexican peso
    'CLP', // Chilean peso
    'ARS', // Argentine peso
    'COP', // Colombian peso
    'PEN', // Peruvian sol
    'IDR', // Indonesian rupiah
    'VND', // Vietnamese đồng
    'ILS', // Israeli new shekel (often formatted with the symbol after the amount)
    'PKR', // Pakistani rupee
    'NGN', // Nigerian naira
    'UGX', // Ugandan shilling
    'TZS', // Tanzanian shilling
    'KES', // Kenyan shilling
    'KZT', // Kazakhstani tenge
    'UAH', // Ukrainian hryvnia
    'GHS', // Ghanaian cedi
    'MUR', // Mauritian rupee
    'MZN', // Mozambican metical
    'BAM', // Bosnia and Herzegovina convertible mark
    'RON', // Romanian leu
    'BGN', // Bulgarian lev
    'HRK', // Croatian kuna
    'MKD', // Macedonian denar
    'RSD', // Serbian dinar
    'JOD', // Jordanian dinar
    'MAD', // Moroccan dirham
    'TND', // Tunisian dinar
    'DZD', // Algerian dinar
    'EGP', // Egyptian pound
    'KWD', // Kuwaiti dinar
    'BHD', // Bahraini dinar
    'OMR', // Omani rial
    'QAR', // Qatari riyal
    'AED', // UAE dirham
    'SAR', // Saudi riyal
    'IQD', // Iraqi dinar
    'LBP', // Lebanese pound
    'SYP', // Syrian pound
    'YER', // Yemeni rial
    'HNL', // Honduran lempira
    'RWF', // Rwandan franc
    'MGA', // Malagasy ariary
    'AFN', // Afghan afghani
    'BIF', // Burundian franc
    'CDF', // Congolese franc
    'GNF', // Guinean franc
    'KIP', // Laotian kip
    'MMK', // Myanmar kyat
    'MNT', // Mongolian tugrik
    'NPR', // Nepalese rupee
    'SBD', // Solomon Islands dollar
    'TOP', // Tongan paʻanga
    'TVD', // Tuvaluan dollar
    'MOP', // Macanese pataca
    'BND', // Brunei dollar
    'PAB', // Panamanian balboa
    'KYD', // Cayman Islands dollar
    'GEL', // Georgian lari
    'KPW', // North Korean won
    'LAK', // Laotian kip
    'MWK', // Malawian kwacha
    'BWP', // Botswanan pula
    'ETB', // Ethiopian birr
    'KGS', // Kyrgyzstani som
    'NAD', // Namibian dollar
    'SLL', // Sierra Leonean leone
    'SZL', // Swazi lilangeni
    'TJS', // Tajikistani somoni
    'TMT', // Turkmenistani manat
    'UZS', // Uzbekistani som
    'XAF', // Central African CFA franc
    'XOF', // West African CFA franc
    'XPF', // CFP franc
    'CUP', // Cuban peso
    'DOP', // Dominican peso
    'KHR', // Cambodian riel
    'MVR', // Maldivian rufiyaa
    'NIO', // Nicaraguan córdoba
    'SHP', // Saint Helena pound
    'TTD', // Trinidad and Tobago dollar
    'XDR', // International Monetary Fund (IMF) Special Drawing Rights
    'STN', // São Tomé and Príncipe dobra
    'SVC', // Salvadoran colón
    'JMD', // Jamaican dollar
    'PYG', // Paraguayan guarani
    'TWD', // New Taiwan dollar
    'BBD', // Barbadian dollar
    'AWG', // Aruban florin
    'FJD', // Fijian dollar
    'GMD', // Gambian dalasi
    'HTG', // Haitian gourde
];